import { render, staticRenderFns } from "./SideBarMobile.vue?vue&type=template&id=838c942a&scoped=true"
import script from "./SideBarMobile.vue?vue&type=script&lang=js"
export * from "./SideBarMobile.vue?vue&type=script&lang=js"
import style0 from "./SideBarMobile.vue?vue&type=style&index=0&id=838c942a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "838c942a",
  null
  
)

export default component.exports